import Icon from '../components/Icon.vue'

Icon.register({
  'file-word': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248C234.8 160 224 149.2 224 136zM281.1 256H305C312.7 256 318.4 263.1 316.7 270.7L278.7 438.7C277.5 444.2 272.6 448 267 448H229C223.5 448 218.7 444.2 217.4 438.9 191.6 335.4 196.6 357.7 191.8 328.4H191.3C190.2 342.7 188.9 345.8 165.7 438.9 164.4 444.2 159.6 448 154.1 448H117C111.4 448 106.5 444.1 105.3 438.6L67.5 270.6C65.8 263.1 71.5 256 79.2 256H103.7C109.4 256 114.4 260 115.5 265.7 131.1 343.7 135.6 375.2 136.5 387.9 138.1 377.7 143.8 355.2 165.9 265.2 167.2 259.8 172 256.1 177.6 256.1H206.7C212.3 256.1 217.1 259.9 218.4 265.3 242.4 365.7 247.2 389.3 248 394.7 247.8 383.5 245.4 376.9 269.6 265.5 270.6 259.9 275.5 256 281.1 256zM384 121.9V128H256V0H262.1C268.5 0 274.6 2.5 279.1 7L377 105C381.5 109.5 384 115.6 384 121.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-word.js
// module id = nscl
// module chunks = 144